export const EMAIL_A_FRIEND_LABELS = {
  th: {
    modalTitle: "อีเมลถึงเพื่อน",
    sharingLabel: "แชร์:",
    privacyPolicy: "นโยบายความเป็นส่วนตัว",
    requiredFields: "*ช่องที่ต้องกรอก",
    nameLabel: "ชื่อ*",
    emailLabel: "อีเมล*",
    emailCopyHint: "(เราจะส่งสำเนาให้คุณ)",
    recipientEmailLabel: "อีเมลผู้รับ*",
    recipientEmailHint:
      "(ป้อนที่อยู่อีเมลหนึ่งหรือมากกว่า คั่นด้วยเครื่องหมายจุลภาค)",
    messageLabel: "ข้อความ",
    messagePlaceholder: "  เพิ่มข้อความที่นี่",
    sendButton: "ส่ง",
    sendingButton: "กำลังส่ง…",
    cancelButton: "ยกเลิก",
    closeButton: "ปิด",
    successTitle: "สำเร็จ",
    successMessage: "อีเมลของคุณถูกส่งเรียบร้อยแล้ว",
    errorName: "กรุณากรอกชื่อของคุณ",
    errorEmail: "กรุณากรอกที่อยู่อีเมลของคุณ",
    errorEmailInvalid: "กรุณากรอกที่อยู่อีเมลที่ถูกต้อง",
    errorRecipientEmail: "กรุณากรอกอีเมลผู้รับ",
    errorRecipientEmailInvalid: "กรุณากรอกที่อยู่อีเมลผู้รับที่ถูกต้อง",
    errorCaptcha: "กรุณายืนยัน captcha",
    errorCaptchaFailed: "การยืนยัน captcha ล้มเหลว กรุณาลองอีกครั้ง",
    errorGeneric: "มีบางอย่างผิดพลาด กรุณาลองอีกครั้ง",
  },
  en: {
    modalTitle: "Email a Friend",
    sharingLabel: "Sharing:",
    privacyPolicy: "Privacy Policy",
    requiredFields: "*Required fields",
    nameLabel: "Name*",
    emailLabel: "Email*",
    emailCopyHint: "(We will send you a copy)",
    recipientEmailLabel: "Recipient(s) Email*",
    recipientEmailHint:
      "(Enter one or more email addresses, separated by a comma.)",
    messageLabel: "Message",
    messagePlaceholder: "  Add Message Here",
    sendButton: "Send",
    sendingButton: "Sending…",
    cancelButton: "Cancel",
    closeButton: "Close",
    successTitle: "SUCCESS",
    successMessage: "Your mail has been sent successfully.",
    errorName: "Please provide your name.",
    errorEmail: "Please provide your email address.",
    errorEmailInvalid:
      "Please enter a valid e-mail address: at least 5 characters and contains an @ and at least one dot.",
    errorRecipientEmail: "Please provide recipient(s) email.",
    errorRecipientEmailInvalid:
      "You must enter a valid email, or comma separate multiple.",
    errorCaptcha: "Please verify the captcha.",
    errorCaptchaFailed: "Captcha verification failed. Please try again.",
    errorGeneric: "Something went wrong. Please try again.",
  },
};
